import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResetPasswordRequest } from 'src/app/Services/auth.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { UsersService } from 'src/app/Services/users.service';
import { NotificationTypes } from 'src/app/app.enums';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css'],
    providers: [UsersService],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  public formData: ResetPasswordRequest = {} as ResetPasswordRequest;
  public userId!: string | null;
  public resetToken: string | null = null;

  constructor(private router: Router,
    private ngxSpinnerService: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private notificationsService: NotificationsService,
    private userService: UsersService,
    private transloco: TranslocoService
  ) { }

  public ngOnInit() {
    this.activatedRoute.paramMap.subscribe((params) => {
      if (params) {
        this.userId = params.get('id');
        this.resetToken = params.get('code');
      } else {
        //since the sessionId is not returned, redirect the user to the home page
        this.router.navigate(['/']);
      }
    });
  }

  public generateNewPassword(): void {
    this.ngxSpinnerService.show();
    this.formData.ResetPasswordToken = this.resetToken;
    this.userService.resetForgottenPassword(this.userId!, this.formData).subscribe(
      (response) => {
        console.log(response);
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.router.navigate(['/']);
          this.notificationsService.showNotification(this.transloco.translate('forgotPassword.success'), response.ResponseMessage, NotificationTypes.Success);
        }
        else {
          this.notificationsService.showNotification(this.transloco.translate('forgotPassword.error'), response.ResponseMessage, NotificationTypes.Error);
        }
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
  }

  public isPasswordMismatch(): boolean {
    return this.formData.NewPassword !== this.formData.ConfirmPassword;
  }


  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.generateNewPassword();
    }
  }
}
